<!-- eslint-disable vue/no-v-html -->
<template>
  <ThePopUp
    :is-open="isShowPopUp"
    :mask-closable="false"
    @close="isShowPopUp = false"
  >
    <div class="py-2 tablet:px-2">
      <div class="relative mb-5">
        <strong class="block pr-6 text-2xl">
          {{ t('title') }}
        </strong>
        <button class="absolute right-0 top-1 h-6 w-6" @click="handleClose">
          <IconClose class="h-full w-full text-black" />
        </button>
      </div>
      <div class="font-mono text-base text-gray-600">
        <p
          class="mb-6"
          v-html="
            provideSanitized(
              decode(t('content', { time: maintenanceTimePeriod }))
            )
          "
        />
        <p v-html="provideSanitized(decode(t('sincerely')))" />
      </div>
    </div>
  </ThePopUp>
</template>

<script setup lang="ts">
  import { decode } from 'entities';

  const { t } = useI18n({ useScope: 'local' });
  const profileStore = useProfileStore();
  const { profile } = storeToRefs(profileStore);

  const isShowPopUp = ref<boolean>(false);

  const maintenanceTimePeriod = computed(
    (): string | null => profile.value.maintenanceTimePeriod
  );

  const setMaintenancePopUp = (): void => {
    /**
     * 開啟系統維護頁面 PopUp
     */

    if (maintenanceTimePeriod.value !== null) {
      if (sessionStorage.getItem('showAnnouncement') === null) {
        sessionStorage.setItem('showAnnouncement', 'true');
      }
      if (sessionStorage.getItem('showAnnouncement') === 'true') {
        isShowPopUp.value = true;
      }
    }
  };

  const handleClose = (): void => {
    sessionStorage.setItem('showAnnouncement', 'false');
    isShowPopUp.value = false;
  };

  watch(maintenanceTimePeriod, () => {
    setMaintenancePopUp();
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "System Maintenance Announcement",
    "content": "Dear Customers:&lt;br&gt;To ensure the highest security and performance level of our services, we will update our service {time}. During this period, WISE may not process any transaction online. We apologize for any inconvenience and please contact us if you need any assistance.",
    "sincerely": "Sincerely,<br>Advantech WISE Team"
  },
  "en-jp": {
    "title": "System Maintenance Announcement",
    "content": "Dear Customers:&lt;br&gt;To ensure the highest security and performance level of our services, we will update our service {time}. During this period, WISE may not process any transaction online. We apologize for any inconvenience and please contact us if you need any assistance.",
    "sincerely": "Sincerely,<br>Advantech WISE Team"
  },
  "en-tw": {
    "title": "System Maintenance Announcement",
    "content": "Dear Customers:&lt;br&gt;To ensure the highest security and performance level of our services, we will update our service {time}. During this period, WISE may not process any transaction online. We apologize for any inconvenience and please contact us if you need any assistance.",
    "sincerely": "Sincerely,<br>Advantech WISE Team"
  },
  "en-kr": {
    "title": "System Maintenance Announcement",
    "content": "Dear Customers:&lt;br&gt;To ensure the highest security and performance level of our services, we will update our service {time}. During this period, WISE may not process any transaction online. We apologize for any inconvenience and please contact us if you need any assistance.",
    "sincerely": "Sincerely,<br>Advantech WISE Team"
  },
  "en-americas": {
    "title": "System Maintenance Announcement",
    "content": "Dear Customers:&lt;br&gt;To ensure the highest security and performance level of our services, we will update our service {time}. During this period, WISE may not process any transaction online. We apologize for any inconvenience and please contact us if you need any assistance.",
    "sincerely": "Sincerely,<br>Advantech WISE Team"
  },
  "en-asia-pacific": {
    "title": "System Maintenance Announcement",
    "content": "Dear Customers:&lt;br&gt;To ensure the highest security and performance level of our services, we will update our service {time}. During this period, WISE may not process any transaction online. We apologize for any inconvenience and please contact us if you need any assistance.",
    "sincerely": "Sincerely,<br>Advantech WISE Team"
  },
  "en-emea": {
    "title": "System Maintenance Announcement",
    "content": "Dear Customers:<br>To ensure the highest security and performance level of our services, we will update our service {time}. During this period, WISE may not process any transaction online. We apologize for any inconvenience and please contact us if you need any assistance.",
    "sincerely": "Sincerely,<br>Advantech WISE Team"
  },
  "ja-jp": {
    "title": "システムメンテナンスのお知らせ",
    "content": "お客様各位：<br>WISE のサービスの改善や正常な維持運営のため，{time} にメンテナンスを実施します。<br/>この期間中、WISE はオンライン取引を処理できない可能性があります。 ご不便をおかけいたしますが、サポートが必要な場合はご連絡ください",
    "sincerely": "敬具<br>Advantech WISE チーム"
  },
  "zh-cn": {
    "title": "系统维护公告",
    "content": "亲爱的客户：<br>为了确保我们服务的更高安全性和卓越性能，我们计划于 {time} 更新服务。在此期间，研华工业云应用市集可能暂时无法处理在线交易，我们对此可能造成的不便深表歉意。<br>若您在更新期间遇到任何问题或需要任何帮助，请随时联系我们，我们将竭诚为您解答和提供支持，感谢您的理解与配合。",
    "sincerely": "此致<br/>敬礼！<br>研华工业云应用市集团队"
  },
  "zh-tw": {
    "title": "系統維護公告",
    "content": "親愛的客戶：<br>為了確保我們服務的最高安全性和效能水平，我們將在 {time} 更新我們的服務。在此期間，WISE 可能無法處理任何線上交易。如有任何不便，我們深表歉意，如果您需要任何協助，請與我們聯絡。",
    "sincerely": "Sincerely,<br>Advantech WISE 團隊"
  }
}
</i18n>
